import styled from 'styled-components';
import ArrowLeftDetailsOneSvg from '../assets/hotels/details/arrow-left-1.svg';

const ArrowLeftDetailsOneIcon = styled(ArrowLeftDetailsOneSvg as JSX.Element)`
  width: ${props => props.width || '1.5rem'};
  height: ${props => props.height || '1.5rem'};
  fill: ${props => props.fill || props.theme.colors.goBrandBlue.base};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default ArrowLeftDetailsOneIcon;
